import * as React from 'react';
import Base from './Base';
const Paragraph = React.forwardRef((props, ref) => (React.createElement(Base, Object.assign({ ref: ref }, props, { component: "div" }))));
export default Paragraph;
